<template>
  <div>
    <my-head></my-head>
    <div class="union minH">
      <div class="crumbs">
        首页 >
        <span style="color: #1d2129">国际联盟</span>
      </div>

      <div class="title flex-center">国际联盟</div>
      <div class="text">
        由国家知识产权国际运营（上海）平台的实体运营公司上海国际知识产权运营管理有限公司发起，国内外交易机构、高校、科研机构、产业园区、知识产权服务机构、金融机构、商会、行业协会、科技企业等参与共建的开放式联盟组织。秉承国际化、市场化、专业化的建设理念，联盟发展聚焦知识产权跨境交易、金融创新、产业运营、知识产权布局及应用保护等功能建设，构建覆盖知识产权创造、保护、应用、管理和服务全链条的国际知识产权交易运营和金融创新生态圈，服务于国际知识产权及技术的转移转化全过程。
      </div>

      <div class="margin-auto union_rectangle"></div>

      <div class="title flex-center">联盟成员</div>

      <div class="un_list flex-wrap">
        <div class="un_col" v-for="(item, index) in unlist" :key="index">
          <img :src="item.img" class="un_icon margin-auto" />
          <div class="un_name flex-center">{{ item.name }}</div>
          <div class="un_ename flex-center">{{ item.ename | datesmall }}</div>
          <div class="flex-center">
            <a href="javascript:;" class="un_ck" @mouseover="colchange(index)" @mouseleave="colshow = null">查看成员</a>
          </div>

          <div class="un_colup" :style="(index + 1) % 3 === 0 ? 'right:65%' : 'left:65%'" v-show="colshow == index">
            <div class="un_colup_title">{{ item.name }}</div>
            <div class="un_colup_content" v-html="item.content"></div>
          </div>
        </div>
      </div>

      <div class="title flex-center">加入联盟</div>

      <div class="un_contacts flex-center">
        <div class="flex-center">
          <img src="../../assets/icon/union_14.png" class="un_contacts_icon" />
          <div>
            <p class="un_contacts_p1">详情请致电</p>
            <p class="un_contacts_p2">(8621) 5063 3728 转 8051</p>
          </div>
        </div>

        <div class="flex-center">
          <img src="../../assets/icon/union_15.png" class="un_contacts_icon" />
          <div>
            <p class="un_contacts_p1">发送电子邮件至</p>
            <p class="un_contacts_p2">membership@sinoip.net</p>
          </div>
        </div>
      </div>
    </div>
    <my-footer></my-footer>
  </div>
</template>

<script>
import MyHead from "../../components/MyHead.vue";
import MyFooter from "../../components/MyFooter.vue";
export default {
  components: { MyHead, MyFooter },
  data() {
    return {
      unlist: [
        {
          name: "行业协会",
          ename: "guild",
          img: require("../../assets/icon/union_1.png"),
          content: `<div>上海市闵行区知识产权协会</div>
                    <div>长三角知识产权运营联盟</div>
                    <div>上海移动互联网产业促进中心</div>`,
        },
        {
          name: "高校",
          ename: "university",
          img: require("../../assets/icon/union_2.png"),
          content: `<div>上海科学院</div>
                    <div>牛津大学创新技术转移（苏州）有限公司</div>
                    <div>上海第二工业大学</div>`,
        },
        {
          name: "科研机构",
          ename: "scientific institution",
          img: require("../../assets/icon/union_3.png"),
          content: `<div>中国科学院微小卫星创新研究院</div>
                    <div>中国科学院上海微系统与信息技术研究所</div>
                    <div>上海汇智达科技创新与知识产权研究院</div>
                    <div>上海紫荆清大知识产权代理有限公司（清华海峡研究院知识产权中心)</div>`,
        },
        {
          name: "知识产权服务机构",
          ename: "intellectual property services",
          img: require("../../assets/icon/union_4.png"),
          content: `<div>苏州七星天专利运营管理有限责任公司</div>
                    <div>上海智化利知识产权有限公司</div>
                    <div>上海新诤信知识产权服务股份有限公司</div>
                    <div>上海三维知识产权服务有限责任公司</div>
                    <div>上海汉光知识产权数据科技有限公司</div>
                    <div>上海硅知识产权交易中心有限公司</div>
                    <div>上海高航知识产权服务有限公司</div>
                    <div>容橙（上海）知识产权运营有限公司</div>
                    <div>Ocean Tomo中国</div>
                    <div>安徽省徽腾知识产权股份有限公司</div>
                    <div>上海洪至知识产权服务中心</div>
                    <div>金轩睿阳（上海）知识产权服务公司</div>
                    <div>苏州隽灿文化传播有限公司</div>
                    <div>甘肃高发产权交易咨询服务有限公司</div>
                    <div>IPwe,Inc.智链知产金融科技（青岛）有限公司</div>
                    <div>华进专利商标代理有限公司上海分公司（分公司不代理专利）</div>
                    <div>上海奥凯知识产服务有限公司</div>
                    <div>上海吉码数字技术有限公司</div>
                    <div>上海誉慈企业管理有限公司（所会员）</div>
                    <div>知链众象知识产权咨询有限公司</div>
                    <div>上海东缘商务信息咨询有限公司（所会员）</div>
                    <div>上海浦东智产科技服务中心</div>`,
        },
        {
          name: "律所/事务所",
          ename: "law firm",
          img: require("../../assets/icon/union_5.png"),
          content: `<div>中国国际贸易促进委员会专利商标事务所</div>
                    <div>上海知信律师事务所</div>
                    <div>上海知锦知识产权代理事务所（特殊普通合伙）</div>
                    <div>上海市协力律师事务所</div>
                    <div>上海市锦天城律师事务所</div>
                    <div>上海盛知华知识产权服务有限公司</div>
                    <div>上海融力天闻律师事务所</div>
                    <div>上海隆天律师事务所</div>
                    <div>日本正林国际特许商标事务所</div>
                    <div>北京市隆安律师事务所</div>
                    <div>美国高博金律师事务所驻上海代表处</div>
                    <div>上海汉盛律师事务所</div>
                    <div>上海段和段律师事务所</div>
                    <div>上海专利商标事务所有限公司</div>
                    <div>上海兰迪律师事务所</div>
                    <div>上海普盛律师事务所（江东投资）</div>
                    <div>德恒上海律师事务所</div>
                    <div>上海申浩律师事务所</div>
                    <div>上海海华永泰律师事务所</div>
                    <div>上海中朴律师事务所</div>
                    <div>北京集佳律师事务所上海分所</div>
                    <div>上海大邦律师事务所</div>`,
        },
        {
          name: "知识产权代理机构",
          ename: "intellectual property agency",
          img: require("../../assets/icon/union_6.png"),
          content: `<div>上海硕力知识产权代理事务所（普通合伙）</div>
                    <div>上海世圆知识产权代理有限公司</div>
                    <div>上海申汇专利代理有限公司</div>
                    <div>上海容智知识产权代理有限公司</div>
                    <div>上海领誉知识产权代理有限公司</div>
                    <div>上海立群专利代理事务所（普通合伙）</div>
                    <div>上海百一知识产权代理有限公司</div>
                    <div>南京弘权知识产权代理有限公司</div>
                    <div>上海一平知识产权代理有限公司</div>
                    <div>上海思捷知识产权代理有限公司</div>
                    <div>上海元好知识产权代理有限公司</div>
                    <div>上海上谷知识产权代理有限公司</div>
                    <div>北京路浩知识产权代理有限公司上海分公司</div>
                    <div>上海点威知识产权代理有限公司</div>
                    <div>上海欣创专利商标事务所</div>
                    <div>上海锻创知识产权代理有限公司</div>
                    <div>上海正则创壹知识产权代理有限公司</div>
                    <div>上海成康知识产权服务有限公司</div>
                    <div>上海紫荆清大知识产权代理有限公司</div>`,
        },
        {
          name: "知识产权评估机构",
          ename: "intellectual property evalution",
          img: require("../../assets/icon/union_7.png"),
          content: `<div>中鸿茂盛资产评估有限责任公司</div>
                    <div>上海新业资产评估有限公司</div>
                    <div>上海大华资产评估有限公司</div>
                    <div>上海必利专利评估技术有限公司</div>
                    <div>广州集佳资产评估有限公司</div>
                    <div>北京中鹏衡资产评估有限公司</div>`,
        },
        {
          name: "金融企业",
          ename: "Corporate Finance",
          img: require("../../assets/icon/union_8.png"),
          content: `<div>上海联合金融信息服务有限公司</div>
                    <div>上海仁仁资产管理有限公司</div>
                    <div>招商银行股份有限公司上海分行</div>
                    <div>上海东方惠金融资担保有限公司</div>`,
        },
        {
          name: "科研企业",
          ename: "scientific research",
          img: require("../../assets/icon/union_9.png"),
          content: `<div>上海数字电视国家工程研究中心有限公司</div>
                    <div>北京知产宝网络科技发展有限公司</div>
                    <div>北京合享智慧科技有限公司</div>
                    <div>南京橙麦信息技术有限公司</div>
                    <div>上海景格科技股份有限公司</div>
                    <div>深圳市SML科技发展有限公司</div>
                    <div>知繁业茂（上海）科技信息技术有限责任公司</div>
                    <div>上海胜璞信息科技有限公司</div>
                    <div>上海华如人工智能科技有限公司</div>
                    <div>上海青顾企业服务中心</div>
                    <div>上海湃通科技有限公司</div>
                    <div>正泰启迪（上海）科技发展有限公司</div>
                    <div>上海海大技术转移有限公司</div>
                    <div>上海诣致知识产权服务有限公司（筹）</div>
                    <div>欧比特航天科技有限公司</div>`,
        },
        {
          name: "电子信息技术企业",
          ename: "Electronic and Information",
          img: require("../../assets/icon/union_10.png"),
          content: `<div>上海浦东软件园信息技术股份有限公司</div>
                    <div>中微半导体设备（上海）股份有限公司</div>
                    <div>通富微电子股份有限公司</div>
                    <div>上海芯物科技有限公司</div>
                    <div>上海天马微电子有限公司</div>
                    <div>上海商汤智能科技有限公司</div>
                    <div>上海国茂数字技术有限公司</div>
                    <div>上海电科电器科技有限公司</div>
                    <div>加特兰微电子科技（上海）有限公司</div>
                    <div>广盟数据科技（上海）有限公司</div>`,
        },
        {
          name: "生物医药企业",
          ename: "biomedicine",
          img: require("../../assets/icon/union_11.png"),
          content: `<div>上海中溢精准医疗科技有限公司</div>
                    <div>上海诣致生物科技合伙企业(有限合伙)</div>
                    <div>上海大泽生物科技有限公司</div>
                    <div>上海奕谱生物科技有限公司</div>
                    <div>上海派森诺生物科技有限公司</div>
                    <div>上海市卫生和健康发展研究中心（上海市医学科学技术情报研究所）</div>`,
        },
        {
          name: "商务服务企业",
          ename: "Business Services",
          img: require("../../assets/icon/union_12.png"),
          content: `<div>上海京航创业孵化器管理有限公司</div>
                    <div>太库（上海）企业发展有限公司</div>
                    <div>上海创业邦传媒文化有限公司</div>
                    <div>上海仁程科技服务有限公司</div>
                    <div>上海鼎贵洋企业管理咨询有限公司</div>
                    <div>茄子（上海）管理咨询有限公司</div>
                    <div>德国汉堡中国联络处（上海瀚堡商务管理咨询有限公司）</div>
                    <div>中商北斗华东供应链管理有限公司</div>
                    <div>浙江度衍信息技术有限公司</div>
                    <div>上海雅知科技发展有限公司</div>
                    <div>大嘉科技（上海）有限公司</div>
                    <div>国科（上海）企业发展有限公司</div>
                    <div>晟宸悦（上海）企业管理咨询有限公司</div>
                    <div>上海晟唐创业孵化器管理有限公司</div>
                    <div>上海萃识商务信息咨询有限公司</div>
                    <div>上海柒捌玖零实业发展有限公司</div>
                    <div>源东（上海）管理咨询有限公司</div>
                    <div>上海新微科技发展有限公司（新微创源孵化器）</div>`,
        },
        {
          name: "制造企业",
          ename: "Manufacturer company",
          img: require("../../assets/icon/union_13.png"),
          content: `<div>上海保隆汽车科技股份有限公司</div>
                    <div>沪东中华造船（集团）有限公司</div>
                    <div>上海安可科技股份有限公司</div>
                    <div>上海中科辰新卫星技术有限公司</div>`,
        },
        {
          name: "国际联盟",
          ename: "League of Nations",
          img: require("../../assets/icon/union_16.png"),
          content: `<div>上海瀚堡商务管理咨询有限公司（汉堡驻中国联络处）</div>
                    <div>法国Laurent Charras知识产权事务所</div>
                    <div>Ocean Tomo中国</div>
                    <div>尼日利亚食品和农业加工商协会</div>
                    <div>日本正林国际特许商标事务所</div>
                    <div>塞内加尔METRAF公司</div>
                    <div>斯里兰卡国际商业委员会</div>
                    <div>泰国企业家发展基金会</div>
                    <div>松下新加坡研发中心</div>
                    <div>印度SkyQuest技术咨询私人有限公司</div>
                    <div>越南科技应用与创业中心</div>
                    <div>牛津大学创新技术转移（苏州）有限公司</div>
                    <div>巴基斯坦伊斯兰堡妇女工商会</div>
                    <div>柬埔寨国家科学技术委员会总秘书处 </div>
                    <div>尼日利亚环球有限公司</div>
                    <div>乌干达马凯雷雷大学</div>
                    <div>美国高博金律师事务所驻上海代表处</div>`,
        },
      ],
      colshow: null,
    };
  },
  methods: {
    colchange(i) {
      this.colshow = i;
    },
  },
};
</script>

<style lang="scss">
.union {
  width: 80%;
  margin: 24px auto 60px;

  .un_contacts {
    padding-top: 55px;
    color: #ffffff;

    &>div {
      width: 456px;
      height: 110px;
      border-radius: 67px;

      .un_contacts_p1 {
        font-size: 14px;
        font-weight: 400;
        line-height: 22px;
        margin-bottom: 4px;
      }

      .un_contacts_p2 {
        font-size: 20px;
        font-weight: 500;
        line-height: 32px;
      }

      .un_contacts_icon {
        height: 36px;
        margin-right: 24px;
        padding-right: 24px;
        border-right: rgba($color: #ffffff, $alpha: 0.2) solid 1px;
      }
    }

    &>div:first-child {
      background: #165dff;
      margin-right: 32px;
    }

    &>div:last-child {
      background: #27ae60;
    }
  }

  .un_list {
    display: flex;
    justify-content: space-around;
    align-items: flex-start;

    .un_col {
      width: 30%;
      margin-bottom: 80px;
      position: relative;

      .un_colup {
        width: 370px;
        padding: 32px 0 32px 32px;
        background: #ffffff;
        box-shadow: 0px 8px 24px 1px rgba(5, 43, 65, 0.32);
        border-radius: 12px;
        position: absolute;
        top: 20%;
        z-index: 5;

        .un_colup_title {
          font-size: 22px;
          font-weight: 500;
          color: #1d2129;
          line-height: 32px;
          margin-bottom: 32px;
        }

        .un_colup_content {
          font-size: 16px;
          font-weight: 400;
          color: #4e5969;
          line-height: 36px;
        }
      }

      .un_ck {
        font-size: 10px;
        margin-top: 4px;
        font-weight: 400;
        color: #165dff;
        line-height: 18px;
      }

      .un_ename {
        font-size: 10px;
        font-weight: 400;
        color: #4e5969;
        line-height: 18px;
      }

      .un_name {
        font-size: 16px;
        font-weight: bold;
        color: #1d2129;
        line-height: 24px;
      }

      .un_icon {
        width: 129px;
        margin-bottom: 16px;
      }
    }
  }

  .union_rectangle {
    width: 65px;
    height: 5px;
    background: #4080ff;
    margin-bottom: 24px;
  }

  .title {
    font-size: 24px;
    font-weight: bold;
    color: #1d2129;
    line-height: 32px;
    margin-bottom: 24px;
  }

  .text {
    font-size: 14px;
    font-weight: 400;
    color: #4e5969;
    line-height: 28px;
    margin-bottom: 90px;
  }
}
</style>
